import { render, staticRenderFns } from "./RegisterEventInfo.vue?vue&type=template&id=1a72df03&"
import script from "./RegisterEventInfo.vue?vue&type=script&lang=js&"
export * from "./RegisterEventInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports